<template>
    <v-select v-model="language"
              :items="languages"
              item-value="lang"
              append-icon=""
              dense
              solo
              :color="$variables.v.theme.secondary"
              class="language-selector">
        <template v-slot:selection="{ item }">
            <country-flag :country='item.code'/>
        </template>
        <template v-slot:item="{ item }">
            <div class="d-flex">
                <country-flag class="mr-2" :country='item.code'/>
                <span>{{item.country}}</span>
            </div>
        </template>
    </v-select>
</template>

<script>
    import {available_locales} from "../../i18n";

    // Flag and display name for every language we translate. The language code (key) is the ISO 639-1 code used
    // as the file name in src/locales; "code" is the ISO 3166-1 country code the flag component expects, which
    // does not always match the language code (e.g. Japanese "ja" -> flag "jp"). A locale file with no entry here
    // still shows up, just with a neutral flag and its bare code as the name, instead of breaking.
    const language_table = {
        en: {code: "us", country: "English"},
        de: {code: "de", country: "Deutsch"},
        ru: {code: "ru", country: "Русский"},
        es: {code: "es", country: "Español"},
        fr: {code: "fr", country: "Français"},
        pl: {code: "pl", country: "Polski"},
        it: {code: "it", country: "Italiano"},
        ja: {code: "jp", country: "日本語"},
        zh: {code: "cn", country: "中文"},
        sv: {code: "se", country: "Svenska"},
        no: {code: "no", country: "Norsk"},
        hi: {code: "in", country: "हिन्दी"},
        pt: {code: "pt", country: "Português"},
        ko: {code: "kr", country: "한국어"},
        vi: {code: "vn", country: "Tiếng Việt"},
        nl: {code: "nl", country: "Nederlands"},
        cs: {code: "cz", country: "Čeština"},
        id: {code: "id", country: "Bahasa Indonesia"},
        tr: {code: "tr", country: "Türkçe"},
        uk: {code: "ua", country: "Українська"}, // The Ukrainian language code is "uk", but its flag's country code is "ua" ("uk" as a country code is the United Kingdom), so the two differ here on purpose
        ro: {code: "ro", country: "Română"},
    };

    export default {
        data() {
            return {
                language: this.$lang,
                // Only the languages that actually have a locale file are offered, in a fixed, readable order;
                // anything not in language_table above still appears, with a fallback flag and its bare code
                languages: available_locales
                    .map(lang => ({lang, ...(language_table[lang] || {code: "un", country: lang})}))
                    .sort((a, b) => a.country.localeCompare(b.country)),
            }
        },
        watch  : {
            async language() {
                this.$lang = this.language;
                this.func.set_localstoragedata('$lang', this.$lang);
                if (this.$user.user.auth === true)
                    await this.applyUserLanguage();

                this.$i18n.locale = this.language;
                this.$forceUpdate();
            }
        },
        methods: {
            async applyUserLanguage() {
                await this.func.ax("/php/update_user.php", {
                    func    : "update_language",
                    userid  : this.$user.user.id,
                    token   : this.$user.user.token,
                    language: this.language,
                });
            }
        }
    }
</script>
